import axios from 'axios';

export function subscribeEmail(email) {
  return fetch('/config.json')
  .then(res => res.json())
  .then(config => {
    return axios.post(config.subscribeUrl, { email }, { headers: { 'Content-Type': 'application/json' } });
  });
}